import { Base } from 'app/components/ui/Base'
import { BgRetina } from 'app/components/ui/BgRetina'
import { Container } from 'app/components/ui/Container'
import { LoadingSpinner } from 'app/components/ui/LoadingSpinner'
import { useLayout } from 'app/contexts/LayoutProvider'
import { useGetUserFromToken } from 'app/queries/confirmInvitation'
import { routes } from 'app/routing/routes'
import { parse } from 'query-string'
import React, { useLayoutEffect } from 'react'
import { useErrorHandler } from 'react-error-boundary'
import { Redirect, useLocation } from 'react-router-dom'

import { SignupForm } from './SignupForm'

type Props = {
  isInvitation?: boolean
}

export const Signup = ({ isInvitation }: Props): JSX.Element => {
  const { updateLayoutData } = useLayout()
  const { search } = useLocation()

  useLayoutEffect(() => {
    updateLayoutData({
      title: 'Area sponsor Marketing',
      subTitle:
        'Perché anche la creatività ha bisogno di una lunga preparazione “amministrativa” ;)',
      headerVariant: 'authentication',
    })
  }, [updateLayoutData])

  // Try to get invitation token if is a signup from invitation
  const queryObject = parse(search)
  const invitationToken =
    isInvitation && queryObject['invitation_token']
      ? `${queryObject['invitation_token']}`
      : undefined

  const {
    data: invitedUser,
    error: getUserFromTokenError,
    isLoading: getUserFromTokenLoading,
  } = useGetUserFromToken({
    data: { invitation_token: invitationToken || '' },
    executeOnStart: !!invitationToken,
  })

  useErrorHandler(getUserFromTokenError)

  // Redirect to login if is an invitation and no invitation token is provided
  if (!invitationToken && isInvitation) {
    return <Redirect to={routes.login.path} />
  }

  if (getUserFromTokenLoading) return <LoadingSpinner isFullScreen />

  return (
    <Base>
      <BgRetina bgImage='https://res.cloudinary.com/estra/image/upload/v1628505503/estra20dev/sponsor/signup/signup_bg.svg'>
        <Container>
          <SignupForm
            invitationToken={invitationToken}
            invitedUserEmail={invitedUser ? invitedUser.email : ''}
          />
        </Container>
      </BgRetina>
    </Base>
  )
}
